<template>
  <div id="game">
    <div class="fullpage-container">
      <div class="fullpage-wp" v-fullpage="opts" ref="example">
        <section id="game-1" class="page">
          <div class="section container">
            <div class="title">
              <h1>遊戲簡介</h1>
              <div class="title_underline"></div>
            </div>
            <img src="../assets/images/game-1.png" alt="" srcset="../assets/images/game-1@2x.png 2x" class="img-fluid">
            <div class="section_title animated fadeInLeft">
              歡迎光臨聖地
            </div>
            <div class="sub_title">
              桃園中壢 戶外實境遊戲
            </div>
            <div class="content">
              遊戲長度：
              <br/>
              約3~4小時。免預約，將手機、耳機和遊戲盒放入背包，就能直接出發!
              <br/>
              活動範圍：
              <br/>
              遍及中壢鬧區，一面闖關，還能順便遊覽極富歷史韻味的老城區景點，品嘗不容錯過的經典美食!
            </div>
          </div>
        </section>
        <section id="game-2" class="page">
          <div class="section container">
            <div class="content">
              <img src="../assets/images/game-2.png" alt="" srcset="../assets/images/game-2@2x.png 2x" class="img-fluid">
              <p>
                再過七週就是市長選舉了，不過這一次與往常有點不一樣。長期被英明黨把持的昂格立克市（Unglich City），居然多了一個野心勃勃又充滿理想的挑戰者——鍾立青！面對英明黨背後龐大的勢力和資源，鍾立青的勝算似乎微乎其微。
              </p>
              <p>
                身為他的助選員，你與夥伴們能逆轉劣勢，幫助他成功挑戰市長寶座嗎？
              </p>
            </div>
          </div>
        </section>
        <section id="game-3" class="page">
          <div class="section container">
            <img src="../assets/images/game-3.png" alt="" srcset="../assets/images/game-3@2x.png 2x" class="img-fluid">
            <div class="section_title animated">
              實境遊戲，
              <br/>
              讓中壢更好玩!
            </div>
            <div class="content">
              <p>
                走在中壢鬧區，若無人指引，極可能發生的事是：你永遠地錯過了許多值得細嘗品味的景點，而自己卻渾然不知，未來也沒有機會再發覺。
              </p>
              <p>
                超過190年、中壢最老的媽祖廟，混合台日建築元素的古老宿舍群，揭開台灣街頭運動序幕的中壢事件歷史現場⋯⋯還有還有！位在老街溪畔，氣氛悠閒愜意的客家改建古厝。繁華現代的中壢，其實蘊藏豐富的歷史文化，街邊建物也分別體現不同時代的美學風情。
              </p>
            </div>
          </div>
        </section>
        <section id="game-4" class="page">
          <div class="section container">
            <div class="content">
              <p>
                《聖地》特別規劃的遊戲路線，將引領你們看見7個精選中壢老城區景點。同時，故事情境也會讓你們的旅程更帶感！如果玩不夠，附錄地圖提供更多的景點與美食推薦，讓你們可以盡情探索。
              </p>
              <p>
                <a href="https://www.clubon.space/play/unglich/" class="btn btn-default buy-btn" target="_blank">前往購買</a>
              </p>
            </div>
          </div>
        </section>
      </div>
      <div class="pager">
        <a href="javascript:void(0);"
           v-for="btn in pageNum"
           :class="{active:index == btn - 1}"
           @click="moveTo(btn - 1)">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Game',
    mounted: function () {
      this.$root.title = '遊戲簡介';
    },
    data: function () {
      let self = this;

      return {
        index: 0,
        pageNum: 4,
        opts: {
          start: 0,
          beforeChange: function (ele, current, next) {
            self.index = next;
          },
          afterChange: function (ele, current) {
            self.index = current;
            $('.section_title').removeClass('fadeInLeft');
            $(ele).find('.section_title').addClass('fadeInLeft');
          },
        }
      }
    },
    methods: {
      moveTo: function (index) {
        this.$refs.example.$fullpage.moveTo(index, true);
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/css/global";

  #game {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    h1 {
      width: 100%;
      background: url("../assets/game.svg") center center no-repeat;
      text-indent: 200%;
      overflow: hidden;
      white-space: nowrap;

      @include media-breakpoint-down(sm) {
        background-position: left center;
      }
    }

    @include media-breakpoint-down(sm) {
      img {
        padding: 0 20px;
        max-height: 150px;
      }
    }
  }
</style>
